const solutions = [
  {
    number: "01",
    icon: "ri-file-search-line",
    title: "Análise Pericial do Contrato",
    description:
      "Examinamos cada cláusula do seu contrato bancário com metodologia técnica para identificar irregularidades, taxas ilegais e cobranças indevidas.",
  },
  {
    number: "02",
    icon: "ri-alert-line",
    title: "Identificação de Abusos",
    description:
      "Calculamos as diferenças entre o que foi cobrado e o que deveria ter sido cobrado, mapeando todos os valores pagos indevidamente.",
  },
  {
    number: "03",
    icon: "ri-scales-3-line",
    title: "Revisão Judicial ou Extrajudicial",
    description:
      "Atuamos tanto na negociação direta com o banco quanto no judiciário para garantir a revisão de juros abusivos e redução da sua dívida.",
  },
  {
    number: "04",
    icon: "ri-hand-coin-line",
    title: "Possível Redução da Dívida",
    description:
      "Com a revisão aprovada, você pode ter sua dívida reduzida significativamente ou até recuperar valores que foram cobrados a mais.",
  },
];

export default function Solucao() {
  return (
    <section id="revisao" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="text-[#B32025] text-xs font-semibold uppercase tracking-widest font-sans">
            Nossa Solução
          </span>
          <h2 className="font-serif text-[#1A1A1A] text-3xl lg:text-4xl font-bold mt-3 mb-5">
            Como recuperamos seu dinheiro através da{" "}
            <em className="text-[#B32025] not-italic">revisão de juros</em>
          </h2>
          <p className="text-[#2C2C2C]/70 text-base leading-relaxed font-sans">
            Um processo estruturado, transparente e focado em resultado real para reduzir sua dívida bancária.
          </p>
        </div>

        {/* Solution grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {solutions.map((s) => (
            <div
              key={s.number}
              className="group flex gap-6 p-8 rounded-lg border border-[#E6E6E6] hover:border-[#B32025]/30 hover:bg-[#B32025]/[0.02] transition-all duration-300 cursor-default"
            >
              <div className="flex-shrink-0">
                <div className="w-14 h-14 flex items-center justify-center bg-[#B32025]/8 group-hover:bg-[#B32025]/15 rounded-lg transition-colors">
                  <i className={`${s.icon} text-2xl text-[#B32025] leading-none`} />
                </div>
              </div>
              <div>
                <span className="text-[#B32025] text-xs font-bold font-sans tracking-widest">{s.number}</span>
                <h3 className="font-serif text-[#1A1A1A] text-xl font-bold mt-1 mb-3">{s.title}</h3>
                <p className="text-[#2C2C2C]/70 text-sm leading-relaxed font-sans">{s.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom banner */}
        <div className="mt-16 bg-[#1A1A1A] rounded-lg px-8 py-10 flex flex-col lg:flex-row items-center justify-between gap-6">
          <div className="text-center lg:text-left">
            <p className="font-serif text-white text-2xl font-bold mb-2">
              Análise gratuita e sem compromisso
            </p>
            <p className="text-[#BFBFBF] text-sm font-sans">
              Envie seu contrato agora e descubra se você tem direito à <strong className="text-white">revisão de juros abusivos</strong>.
            </p>
          </div>
          <a
            href="https://wa.me/5554996914900?text=Ol%C3%A1%2C%20gostaria%20de%20solicitar%20a%20an%C3%A1lise%20do%20meu%20contrato%20banc%C3%A1rio."
            target="_blank"
            rel="noopener noreferrer"
            className="flex-shrink-0 flex items-center gap-2 bg-[#B32025] hover:bg-[#8E1A1E] text-white font-semibold px-8 py-4 rounded-md transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-whatsapp-line text-base leading-none" />
            </div>
            Solicitar análise gratuita
          </a>
        </div>
      </div>
    </section>
  );
}
